import { render, staticRenderFns } from "./FormSave.vue?vue&type=template&id=48a20148"
import script from "./FormSave.vue?vue&type=script&lang=js"
export * from "./FormSave.vue?vue&type=script&lang=js"
import style0 from "./FormSave.vue?vue&type=style&index=0&id=48a20148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports